import React from 'react';
import { useOutletContext } from 'react-router-dom';
import ResourcePlanCard from '../../../shared/components/ResourcePlanCard';

/** 域名详情 · 套餐（升级/降级、转移、绑定的域名、资源包、用量） */
const DomainPlan = () => {
    const { domainData, reloadDomain } = useOutletContext();
    if (!domainData?.id) return null;
    return <ResourcePlanCard type="cdn" resourceId={domainData.id} onChanged={reloadDomain} />;
};

export default DomainPlan;
